import { Button, Card } from "@bp/ui-components";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useQuery } from "urql";
import { getFragmentData, graphql } from "../../client/gql";
import { AuditActivityList } from "../../components/AuditActivityList/AuditActivityList";
import { Page } from "../../components/Page/Page";

// Only the display name of the person the feed is filtered to.
const AuditPage_User = graphql(`
  fragment AuditPage_User on User {
    uuid
    email
    profiles {
      listName
    }
  }
`);

const AuditPageQuery = graphql(`
  query AuditPage_Query($uuid: ID!) {
    users(where: { uuid: $uuid }) {
      ...AuditPage_User
    }
  }
`);

/**
 * Global audit feed. `?user=<uuid>` narrows it to one person (linked from the
 * person page's activity card) and shows a removable filter note.
 */
export function AuditPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const userUuid = params.get("user") ?? undefined;
  const [{ data }] = useQuery({
    query: AuditPageQuery,
    variables: { uuid: userUuid ?? "" },
    pause: !userUuid,
  });
  const user = getFragmentData(AuditPage_User, data?.users ?? [])[0];
  const personName = user?.profiles?.[0]?.listName || user?.email || userUuid;

  return (
    <Page
      title="Audit-Log"
      description="Wer hat was bei wem getan. Mit persönlichen Zugängen wird jede Aktion zurechenbar."
    >
      {userUuid && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "var(--spacing-3)",
            marginBottom: "var(--spacing-3)",
            color: "var(--color-grey)",
            fontSize: "var(--font-size-m)",
          }}
        >
          <span>
            Gefiltert auf <strong>{personName}</strong>
          </span>
          <Button hierarchy="tertiary" height="s" onClick={() => navigate("/audit")}>
            Filter entfernen
          </Button>
        </div>
      )}
      <Card contentPadding="none">
        <AuditActivityList
          userUuid={userUuid}
          variant="table"
          limit={100}
          emptyNote="Noch keine protokollierten Ereignisse."
        />
      </Card>
    </Page>
  );
}
